export default "__VITE_ASSET__mNsZzsin__"